"use client";

export default function PopularSug() {
  return (
    <div className="w-[85%] mx-auto  opacity-0  max-h-0">
      <div className="w-[100%] sm:w-[85%] mx-auto">
        <h2 className="text-[28px]/[36px] md:text-[32px]/[40px] lg:text-[36px]/[44px] xl:text-[40px]/[48px] 2xl:text-[48px]/[54px] text-[#000] font-[500] tracking-[-0.03em] mb-[25px] sm:mb-[30px] md:mb-[40px] mb-[30px] md:mb-[30px]">
          Popular Searches
        </h2>
        <div className="opacity-50">
          <span className="after:content-['|'] after:mx-[5px]">PlusWilla</span>
          <span className="after:content-['|'] after:mx-[5px]">Plus Willa</span>
          <span className="after:content-['|'] after:mx-[5px]">PlusVilla</span>
          <span className="after:content-['|'] after:mx-[5px]">Plus Villa</span>
          <span className="after:content-['|'] after:mx-[5px]">VillaPlus</span>
          <span className="after:content-['|'] after:mx-[5px]">Villa Plus</span>
          <span className="after:content-['|'] after:mx-[5px]">Willa</span>
          <span className="after:content-['|'] after:mx-[5px]">Willa 25</span>
          <span className="after:content-['|'] after:mx-[5px]">
            Villa for Sale
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Villa for Sale in Coimbatore
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Villa for Sale in TVS Nagar
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Villa for Sale in Edayarpalayam
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Villa in Coimbatore
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Villa in TVS Nagar
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Villa in Edayarpalayam
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            3 BHK Villa for Sale
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            3 BHK Villa for Sale in Coimbatore
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            3 BHK Villa for Sale in TVS Nagar
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            3 BHK Villa for Sale in Edayarpalayam
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            4 BHK Villa for Sale
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            4 BHK Villa for Sale in Coimbatore
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            4 BHK Villa for Sale in TVS Nagar
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            4 BHK Villa for Sale in Edayarpalayam Villa in Coimbatore
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            3 & 4 BHK Villas in Coimbatore
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            3 & 4 BHK Villas for Sale
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            3 & 4 BHK Villas for Sale in TVS Nagar
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            3 & 4 BHK Villas for Sale in Edayarpalayam
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Luxury Villas in Coimbatore
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Luxury Villas for Sale in Coimbatore
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Luxury Villas for Sale in TVS Nagar
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Luxury Villas for Sale in Edayarpalayam
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Villa for Sale from 2.5 Cr
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            3BHK Villa for Sale from 2 Cr
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            3BHK Villa for Sale from 1.8 Cr 
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Villa for Sale from 1.8 Cr
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Villa for Sale from 2 Cr
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Villa for Sale at 2.5Cr
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Villa for Sale from 2.5 Cr to 3.5 Cr
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Premium Villas in Coimbatore
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Premium Villas for Sale in Coimbatore
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Premium Villas for Sale
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Premium Villas for Sale in TVS Nagar
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Premium Villas for Sale in Edayarpalayam
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Villa for Sale in TVS Nagar
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Just Move In Villa
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            3 BHK Villa for Sale Near Sai Baba Colony
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            4 BHK Villa for Sale Near Sai Baba Colony
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            3 BHK Villa for Sale Near RS Puram
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            4 BHK Villa for Sale Near RS Puram
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Villa for Sale in Mettupalayam Road
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Villa in Thadagam Road
          </span>
          <span className="after:content-['|'] after:mx-[5px]">
            Villa for Sale in Thadagam Road
          </span>
        </div>
      </div>
    </div>
  );
}
